<template>
  <modal :show="show">
    <div slot="modalHeader">
      <modal-header :closeModal="close"><i class="fa fa-edit"></i>&nbsp; Bulk Edit</modal-header>
      <br>
    </div>

    <div class="bulk-edit-modal">
      <div class="form-group row">
        <label for="fields" class="col-sm-4 col-form-label">Select the field to edit: </label>
        <div class="col-sm-8">
          <select id="fields"
                  name="fields"
                  class="form-control"
                  placeholder="Select one field"
                  @change="onFieldSelected($event)">
            <option>Select one field</option>
            <option v-for="(value, key) in creativeUnitFields" :key="key" :value="key">{{ value }}</option>
          </select>
          <small>
            Select the field that you want to update for all the selected units.
          </small>
        </div>
      </div>
      <div class="form-group row" v-if="this.currentFieldIndex !== null">
        <label for="field_value" class="col-sm-4 col-form-label">New value for {{getFieldNameByIndex(currentFieldIndex)}}</label>
        <div class="col-sm-8">
          <dropdown id="field_value"
                    :options="fpsOptions"
                    v-model="model.value"
                    v-if="getFieldTypeEnable('fpsOptions')" />
          <dropdown id="videoFormatOptions"
                    :options="videoFormatOptions"
                    v-model="model.value"
                    v-if="getFieldTypeEnable('videoFormatOptions')" />
          <dropdown id="masterOptions"
                    :options="masterOptions"
                    v-model="model.value"
                    v-if="getFieldTypeEnable('masterOptions')" />
          <dropdown id="compositionOptions"
                    :options="compositionOptions"
                    v-model="model.value"
                    v-if="getFieldTypeEnable('compositionOptions')" />
          <span v-if="getFieldTypeEnable('encodingProfileOptions')" class="dropdown">
                <v-select id="encodingProfileOptions" label="display_name" :options="creative.encoding_profiles" :current="encodingProfileOptions" v-model="model.value" multiple>
                </v-select>
          </span>
          <field v-if="getFieldTypeEnable('string')"
                 :type="'text'"
                 v-model="model.value"
                 :value="model.value"/>
          <field v-if="getFieldTypeEnable('number')"
                 :type="'number'"
                 v-model="model.value"
                 :value="model.value"/>
          <color-picker
              v-if="getFieldTypeEnable('color')"
              :color="model.value"
              :creativeType="this.creativeUnitType"
              v-model="model.value"
              />
          <span
                class="creativeUnitTable__imageField"
                @click="(e) => {this.$emit('onUpdateImage', e)}"
                data-modalType="assetLibrary"
                :data-modalID="'0'"
                :data-modalField="'image'"
                :data-modalFieldType="getFieldNameByIndex(currentFieldIndex)"
                v-if="getFieldTypeEnable('image')"
          >
            <span>
              <span class="item"><i aria-hidden="true" class="fa fa-plus"></i> Change Asset</span>
            </span>
            <span>
              <br/>
              {{model.value}}
              <br/>
            </span>
            <span>
              <span class="thumb item"><img v-if="model.value" :src="thumbPath( model.value )" width="25%"/></span>
            </span>
            <br/>
          </span>

          <span
                class="creativeUnitTable__imageField"
                @click="(e) => {this.$emit('onUpdateImage', e)}"
                data-modalType="assetLibrary"
                :data-modalID="'0'"
                :data-modalField="'image'"
                :data-modalFieldType="getFieldNameByIndex(currentFieldIndex)"
                v-if="getFieldTypeEnable('video') || getFieldTypeEnable('audio')"
          >
            <span>
              <span class="item"><i aria-hidden="true" class="fa fa-plus"></i> Change Asset</span>
            </span>
            <span>
              <br/>
              {{model.value}}
              <br/>
            </span>
            <br/>
          </span>
          <small>
            Add the value for the selected field
          </small>
        </div>
      </div>
    </div>
    <div slot="modalFooter">
      <modal-footer
          :closeModal="() => {close()}"
          :confirm="this.saveChanges"
          :confirmDisabled="!(!!model.value)"
          cancelText="Cancel"
          confirmText="Update"
          confirmTheme="primary" />
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import {modalMixin} from '@/mixins/modalMixin'
import ModalFooter from '@/components/Modal/modal-footer'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import { fpsOptions, videoFormatOptions } from '@/constants/CreativeUnits'
import Field from '@/components/Form/Field/field'
import Tooltip from '@/components/Tooltip/tooltip'
import ColorPicker from '@/components/ColorPicker/color-picker'
import ModalAssetLibrary from '@/components/Modal/assets/modal-asset-library'
import vSelect from 'vue-select'

import { API_URL, AWS_S3_BUCKET } from '@/config'

export default {
  name: 'modal_bulk_edit_unit',
  mixins: [modalMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    Dropdown,
    Field,
    Tooltip,
    ColorPicker,
    ModalAssetLibrary,
    vSelect
  },
  props: {
    show: Boolean,
    tableFields: {},
    tableColumns: {},
    tableFieldTypes: {},
    tableData: {},
    selected: {},
    mastersData: {},
    creativeUnitType: String,
    creative: {},
    triggerBulkEdit: Function
  },
  data: () => ({
    currentFieldIndex: null,
    fpsOptions,
    videoFormatOptions,
    model: {
      value: ''
    }
  }),
  mounted () {},
  created () {},
  computed: {
    creativeUnitFields () {
      let fields = []
      const videoFields = this.creativeUnitType === 'html-video' ? [
        'render_video_duration',
        'render_video_fps',
        'render_video_format'
      ] : []
      if (this.creativeUnitType === 'after-effects') {
        fields = ['composition', 'locale', 'encoding_profile', ...this.tableFields]
      } else {
        fields = ['master', 'locale', 'width', 'height', ...videoFields, ...this.tableFields]
      }
      return fields
    },
    masterOptions () {
      return this.mastersData.map((value) => ({name: value, value}))
    },
    compositionOptions () {
      // let comps = this.creative.compositions.filter(({type}) => type === 'composition')
      return this.creative.compositions.map((value) => ({name: value, value: value}))
    },
    encodingProfileOptions () {
      return this.creative.encoding_profiles.map((value) => ({label: value.name, code: value.display_name}))
    }
  },
  methods: {
    getFieldType: function (fieldIndex) {
      let types = []
      if (this.creativeUnitType === 'after-effects') {
        types = [
          'compositionOptions', // composition
          'string', // locale
          'encodingProfileOptions', // encoding profiles
          ...this.creativeUnitType === 'html-video' ? [
            'number', // render_video_duration
            'fpsOptions', // render_video_fps
            'videoFormatOptions' // render_video_format
          ] : [],
          ...this.tableFieldTypes
        ]
      } else {
        types = [
          'masterOptions', // master
          'string', // locale
          'number', // width
          'number', // height
          ...this.creativeUnitType === 'html-video' ? [
            'number', // render_video_duration
            'fpsOptions', // render_video_fps
            'videoFormatOptions' // render_video_format
          ] : [],
          ...this.tableFieldTypes
        ]
      }
      return (fieldIndex >= 0 && fieldIndex < types.length) ? types[fieldIndex] : undefined
    },
    onFieldSelected: function ($event) {
      this.model.value = ''
      if ($event.target.value) {
        this.currentFieldIndex = $event.target.value
        return true
      }
      this.currentFieldIndex = null
      return false
    },
    getFieldNameByIndex: function (fieldIndex) {
      return this.currentFieldIndex ? this.creativeUnitFields[fieldIndex] : ''
    },
    getFieldTypeEnable: function (fieldType) {
      const type = this.getFieldType(this.currentFieldIndex)
      if (type !== fieldType) return false
      let allowed = false

      switch (type) {
        case 'masterOptions':
          allowed = true
          break
        case 'fpsOptions':
          allowed = true
          break
        case 'videoFormatOptions':
          allowed = true
          break
        case 'string':
          allowed = true
          break
        case 'number':
          allowed = true
          break
        case 'color':
          allowed = true
          break
        case 'image':
          allowed = true
          break
        case 'video':
          allowed = true
          break
        case 'audio':
          allowed = true
          break
        case 'compositionOptions':
          allowed = true
          break
        case 'encodingProfileOptions':
          allowed = true
          break
        default:
          break
      }
      return allowed
    },
    thumbPath (filename) {
      if (this.creativeUnitType === 'after-effects') {
        return `${AWS_S3_BUCKET}${this.creative.campaign.client.slug.toLowerCase()}/${this.creative.campaign.hash_id}/${this.creative.hash_id}/_assets/${filename}?ts=${Math.round(+new Date() / 1000)}`
      } else {
        return API_URL + 'store/' + this.creative.campaign.client.slug.toLowerCase() + '/' + this.creative.campaign.hash_id + '/' + this.creative.hash_id + '/_assets/' + filename + '?ts=' + Math.round(+new Date() / 1000)
      }
    },
    setAssetLibraryImageSelected (image) {
      this.model.value = image
    },
    saveChanges: function () {
      const selectedRows = this.selected().ids
      this.tableData.forEach((item, index) => {
        if (selectedRows.includes(item.id)) {
          const fieldKey = this.getFieldNameByIndex(this.currentFieldIndex)
          if (item.fields.hasOwnProperty(fieldKey)) {
            item.fields[fieldKey] = this.model.value
          } else {
            item[fieldKey] = this.model.value
          }
        }
      })
      this.triggerBulkEdit()
      this.close()
    }
  }
}
</script>
<style scoped>
>>> {
  --vs-controls-color: #2c3247;
  --vs-border-color: rgb(204, 204, 204);

  --vs-dropdown-bg: #2c3247;
  --vs-dropdown-color: #ffffff;
  --vs-dropdown-option-color: #ffffff;

  --vs-selected-bg: #41b883;
  --vs-selected-color: #ffffff;

  --vs-search-input-color: #eeeeee;
  --vs-dropdown-option--active-bg: #41b883;
  --vs-dropdown-option--active-color: #fffff;
}
</style>
<style lang="scss">
.modal__container {
  width: 1000px !important;
}
.bulk-edit-modal {
  .form-control {
    margin-bottom: 0.5rem;
  }
}
.modal_body{
  overflow: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-bulk-edit-unit.vue